@if (data$ | async; as data) {
  <redispatch-planwert-detail-form
    [readonly]="data.readonly"
    [planwert]="data.planwert"
    [erzeugungsanlage]="data.erzeugungsanlage"
    [alreadyAllocatedDatesForDokumentId]="data.alreadyAllocatedDatesForDokumentId"
    [dokumentenId]="dokumentenId"
    [stwId]="stwId">
  </redispatch-planwert-detail-form>
}
